/**
 * Load EraData wanted
 * @param eraName
 * @return {Promise<*>}
 */
export function getCurrentEraData(eraName) {
  return import('../data/' + eraName)
}



// WEBPACK FOOTER //
// ./src/helper/EraDataHelper.js